export default {
      id: "icon-botraining-usage",
      viewBox: "0 0 125 104",
      url: __webpack_public_path__ + "icons.svg#icon-botraining",
      toString: function () {
        return this.url;
      }
    }